<template>
	<div>
		<div class="banner">
			<div class="banner-box">
				<div class="title">小白考研院校数据</div>
				<div class="sTitle">帮你快速了解目标院校资料</div>
				<div class="subscribe">
					<div class="box">
						<div class="btn">
							<span>免费订阅</span>
							<span class="font">></span>
						</div>
						<div class="des">邀请3人点击助力即可订阅</div>
					</div>
				</div>
			</div>
		</div>
		<div class="titleDes">
			<p><span>免费订阅</span> 考研院校数据汇总</p>
			<p>已有3332人订阅成功啦</p>
		</div>
		<div class="helpMe">
			<p class="four">你的朋友 <img class="tou" :src="avatar"><span>{{nickName}}</span> 想要免费</p>
			<p class="five">订阅研小白aap考研院校</p>
			<p class="six" v-show="!isLogin">快来帮帮TA吧</p>
			<p class="sev" v-show="!isLogin">点击下方按钮帮TA助力！</p>
			<div class="helpMeList" v-show="isLogin">
				<div v-for="item,key in helpMe">
					<img :src="item.avatar" alt="">
					<font>{{item.userName}}</font>
				</div>
				<div v-for="item in 3-helpMe.length">
					<img src="../../../asset/5.png" alt="">
					<font>待助力</font>
				</div>
			</div>
			<p @click="goLogin" class="one">助力好友领取</p>
			<p class="two">我也想免费订阅考研资讯</p>
			<p class="tre">邀请好友助力 — 人满助力成功 — 免费</p>
		</div>
		<div class="titleDess">
			<p><span>800多</span> 所院校数据最新汇总</p>
			<p>更快更准确的了解院校动态</p>
		</div>
		<div class="content">
			<div class="box"></div>
		</div>
		<div class="helpBtn">立即邀请研友助力</div>
	</div>
</template>

<script>
	import https from '../../../https.js'
	import {
		Toast
	} from 'vant';
	export default{
		data() {
			return {
				helpMe:[],
				token:'',
				uid:"",
				isLogin:false,
				avatar:"",
				nickName:"",
				LoginStatus:false,
			}
		},
		watch: {
			
		},
		created() {
			console.log(this.$route.query.token)
			this.token = this.$route.query.token;
			var storage = window.sessionStorage;
			
			this.uid = this.$route.query.uid;
			
			if( this.uid ||storage.getItem('uid')){
				this.getInfo()
			}
			if(storage.getItem('LoginStatus')){
				this.LoginStatus = storage.getItem('LoginStatus')
			}
			if(this.uid){
				storage.setItem('uid', this.uid);
				
			}
			
			// if(storage.getItem('open')){
				// (this.token)? (this.isLogin = true) && storage.getItem('open')?this.helpMeCount():"" : (this.isLogin = false)
			// }
			if(this.token){
				this.isLogin = true
				console.log(typeof   storage.getItem('open'))
				if(storage.getItem('open') == "true"){
					this.helpMeCount()
				}
			}else{
				this.isLogin = false
			}
			
		},
		mounted() {
			this.helpMeList()
		},
		methods:{
			getInfo(){
				var storage = window.sessionStorage;
				// var uid = storage.getItem('uid');
				https.fetchGet('/api/api/user/getInfo/'+ (storage.getItem('uid') ? storage.getItem('uid'):this.uid)).then(res => {
					console.log(res)
					this.avatar=res.data.data.avatar;					this.nickName=res.data.data.nickName;
				}).catch(err => {
					console.log(err)
					// Toast.loading({
					// 	message: err.data.data,
					// 	forbidClick: true,
					// })
				
				})
			},
			goLogin(){
				console.log(this.LoginStatus)
				if(this.LoginStatus){
					this.helpMeCount();
				}else{
					this.$router.push({
						name:'login',
            query: {
            	route: "share",
            }
					})
				}
				
			},
			helpMeList(){
				var param = {
					type:'sub_sch'
				}
				var storage = window.sessionStorage;
				var uid = storage.getItem('uid');
				https.fetchGet('/api/share/findList/'+(storage.getItem('uid') ? storage.getItem('uid'):this.uid),param).then(res => {
					// console.log(res.data.data.list.slice(0,3))
					this.helpMe = res.data.data.list.slice(0,3)
					// this.helpMeNum = res.data.data
				}).catch(err => {
					Toast.loading({
						message: err.data.data,
						forbidClick: true,
					})
				
				})
			},
			helpMeCount(){
				var param = {
					type:'sub_sch'
				}
				var storage = window.sessionStorage;
				var uid = storage.getItem('uid');
				
				https.fetchGetToken('/api/share/open/'+ uid,param,this.token).then(res => {
					storage.setItem('open', false);
					this.helpMeNum = res.data.data;
					var data = res.data;
					console.log(data)
					if(data.code == "200"){
						Toast.loading({
							message: "助力成功",
							forbidClick: true,
						})
					}else if(data.code == "500"){
						Toast.loading({
							message: data.msg,
							forbidClick: true,
						})
					}
					this.helpMeList()
				}).catch(err => {
					storage.setItem('open', false);
					console.log(err)
					// Toast.loading({
					// 	message: err.data.data,
					// 	forbidClick: true,
					// })
				
				})
			},
		}
	}
</script>

<style scoped="scoped">
	.four{
		display: flex;
		align-items: center;
	}
	.four span{
		max-width: 250px;
		display: inline-block;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.tou{
		width: 58px;
		height: 58px;
		margin: 0 2px;
		border-radius: 50%;
	}
	.helpMeList {
		width: 100%;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	
	.helpMeList div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.helpMeList div img {
		width: 98px;
		height: 98px;
		margin-top: 32px;
		border-radius: 50%;
	}
	
	.helpMeList div font {
		font-size: 26px;
		font-family: PingFangSC-Regular, PingFang SC, '微软雅黑';
		font-weight: 400;
		color: #999999;
		line-height: 26px;
		padding-top: 26px;
	}
	img {
		width: 100%;
		pointer-events: none;
	}
	
	.banner {
		overflow: hidden;
		width: 750px;
		margin: 0 auto;
		height: 348px;
		background: linear-gradient(180deg, #D9EEFF 0%, #4CA0FF 100%);
	}
	
	.banner-box {
		width: 750px;
		height: 100%;
		background: url(../../../asset/7.png) no-repeat right top 34px;
		background-size: 320px;
	}
	
	.title {
		width: 100%;
		font-size: 54px;
		font-family: Alibaba-PuHuiTi-H, Alibaba-PuHuiTi, '微软雅黑';
		font-weight: normal;
		color: #3F94FF;
		line-height: 1;
		padding: 70px 0 10px 34px;
	}
	
	.sTitle {
		font-size: 36px;
		font-family: Alibaba-PuHuiTi-H, Alibaba-PuHuiTi, '微软雅黑';
		font-weight: normal;
		color: #3F94FF;
		line-height: 1;
		padding: 10px 0 0 34px;
	}
	
	.subscribe {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 30px;
	}
	
	.subscribe .box {
		width: 682px;
		height: 76px;
		background: #FFFFFF;
		box-shadow: 0px 2px 10px 0px rgba(63, 148, 255, 0.3);
		border-radius: 100px;
		display: flex;
		align-items: center;
	}
	
	.subscribe .box .btn {
		display: flex;
		align-items: center;
		height: 76px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 0rem 24px 0rem 30px;
		background: linear-gradient(90deg, #FFA359 0%, #FF7638 100%);
		box-shadow: 0px 2px 10px 0px rgba(63, 148, 255, 0.3);
		border-radius: 38px;
	}
	
	.subscribe .box .btn span {
		font-size: 36px;
		font-family: PingFangSC-Semibold, PingFang SC, '微软雅黑';
		font-weight: 600;
		color: #FFFFFF;
		line-height: 1;
		text-shadow: 0px 2px 10px rgba(63, 148, 255, 0.3), 0px 2px 3.6px rgba(255, 87, 12, 0.65);
	}
	
	.subscribe .box .btn span.font {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 28px;
		height: 28px;
		box-shadow: 0px 2px 10px 0px rgba(63, 148, 255, 0.3);
		border: 2px solid #FFFFFF;
		border-radius: 50px;
		font-size: 20px;
		margin-left: 18px;
	}
	
	.subscribe .box .des {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 36px;
		font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi, '微软雅黑';
		font-weight: normal;
		color: #010102;
	}
	
	.titleDes {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 50px 0 40px 0;
	}
	
	.titleDes p {
		font-size: 40px;
		font-family: PingFangSC-Semibold, PingFang SC, '微软雅黑';
		font-weight: 600;
		color: #000000;
		line-height: 1;
		margin: 0 auto;
	}
	
	.titleDes p span {
		color: #FF4C4C;
	}
	
	.titleDes p:last-child {
		font-size: 26px;
		color: #999999;
		padding-top: 16px;
	}
	
	.helpMe {
		margin: 0 auto;
		width: 686px;
		height: 680px;
		border-radius: 24px;
		border: 2px solid #D0D0D0;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
	}
	
	.helpMe p {
		font-family: PingFangSC-Medium, PingFang SC, '微软雅黑';
		line-height: 1;
		margin: 0;
	}
	
	.helpMe p:first-child {
		font-size: 40px;
		font-weight: 500;
		color: #000000;
		padding-top: 40px;
		line-height: 56px;
	}
	
	.helpMe p:first-child span {
		color: #3F94FF;
	}
	
	.helpMe p:nth-child(2) {
		color: #010102;
		font-size: 36px;
		padding-top: 10ox;
		line-height: 50px;
	}
	
	.helpMe p.six {
		color: #FF4C4C;
		font-size: 36px;
		padding-top: 40px;
		line-height: 50px;
	}
	
	.helpMe p.sev {
		color: #999999;
		font-size: 0.48rem;
		padding-top: 40px;
		line-height: 50px;
	}
	
	.helpMe p.one {
		width: 530px;
		height: 90px;
		background: #FF4C4C;
		border-radius: 45px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 36px;
		color: #FFFFFF;
		margin-top: 60px;
	}
	
	.helpMe p.two {
		width: 530px;
		height: 90px;
		border-radius: 45px;
		border: 2px solid #CCCCCC;
		font-size: 36px;
		color: #000000;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
	}
	
	.helpMe p:last-child {
		font-size: 28px;
		color: #999999;
		padding-top: 26px;
		line-height: 38px;
	}
	
	.titleDess {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 50px 0 40px 0;
	}
	
	.titleDess p {
		font-size: 50px;
		font-family: PingFangSC-Semibold, PingFang SC, '微软雅黑';
		font-weight: 600;
		color: #000000;
		line-height: 50px;
		margin: 0;
	}
	
	.titleDess p span {
		color: #FF4C4C;
	}
	
	.titleDess p:last-child {
		font-size: 30px;
		color: #999999;
		padding-top: 16px;
	}
	.content{
		width: 100%;
		height: 4273px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.content .box{
		width: 626px;
		height: 4273px;
		background: url(../../../asset/13.png);
		background-size: 100% 100%;
	}
	.helpBtn{
		height: 100px;
		font-size: 36px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		background: #FF4C4C;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 50px;
	}
</style>
